import { createContext } from 'react';

import { SelectedEventContextProps } from './SelectedEventContext.types';

export const SelectedEventContext = createContext<SelectedEventContextProps | undefined>(undefined);
